import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Footer } from '@pages/principal/footer/footer';
import { Nav } from '@pages/principal/nav/nav';
import { PrivacyPolicyContentComponent } from '@shared/components/privacy-policy-content/privacy-policy-content.component';

@Component({
    selector: 'app-privacy-policy',
    standalone: true,
    imports: [Nav, Footer, RouterLink,PrivacyPolicyContentComponent],
    templateUrl: './privacy-policy.component.html',
    styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {

}
